import React from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, CartesianGrid } from 'recharts';
import { ChannelData } from '../../../../types/dashboard-v4.types';
import { PanelHeading } from './PanelHeading';

interface ChannelBreakdownChartProps {
  data: ChannelData[];
}

export const ChannelBreakdownChart: React.FC<ChannelBreakdownChartProps> = ({ data }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <PanelHeading>
        Channel breakdown
      </PanelHeading>
      <p className="text-sm text-gray-400 mb-6">
        Updates in your signals and complaints
      </p>
      
      <ResponsiveContainer width="100%" height={200}>
        <BarChart 
          data={data} 
          margin={{ top: 5, right: 20, left: -15, bottom: 5 }}
          barCategoryGap="20%"
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis 
            dataKey="channel" 
            tick={{ fontSize: 12, fill: '#6B7280' }} 
            axisLine={false}
            tickLine={false}
            dy={10}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#6B7280' }}
            width={30}
            domain={[0, 'dataMax']}
          />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color || '#8884d8'} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};